import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SurveyResultsFilterNames } from 'models';
import { IFilterChangePayload } from 'modules/admin-panel/pages/results/models';
import {
	getFromSessionStorage,
	SessionStorageKeyTypes,
} from 'utils/clientStorage';
import {
	calculatedRoundsSelector,
	statisticGroupingTypeSelector,
} from 'modules/admin-panel/pages/results/selectors/dashboard.selectors';
import { setActiveRole } from 'modules/admin-panel/pages/results/results.actions';
import { useSurveyResultsFilter } from '../useSurveyResultsFilter';

export const useSetActiveRole = () => {
	const dispatch = useDispatch();
	const {
		onChangeSurveyResultsFilter,
		surveyFilter,
	} = useSurveyResultsFilter();
	const surveyId = getFromSessionStorage(
		SessionStorageKeyTypes.dashboardSurveyId,
	);
	const rounds = useSelector(calculatedRoundsSelector);
	const groupingType = useSelector(statisticGroupingTypeSelector);

	const boundSetActiveRole = useCallback(
		(p: IFilterChangePayload) => dispatch(setActiveRole(p)),
		[dispatch],
	);

	return useCallback(
		(curRoleId?: number) => {
			boundSetActiveRole({
				rounds,
				surveyId,
				...surveyFilter,
				roleId: curRoleId,
				groupingType,
			});
			onChangeSurveyResultsFilter({
				[SurveyResultsFilterNames.roleId]: curRoleId,
			});
		},
		[
			boundSetActiveRole,
			rounds,
			surveyId,
			groupingType,
			onChangeSurveyResultsFilter,
			surveyFilter,
		],
	);
};
